<div class="verify-otp-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">Verify mobile number</span>
    <span class="page-indicator"><span style="font-weight: 1000;font-size: larger;">1</span>/3</span>
  </div>

  <div class="content-section">
    <p class="instruction-text">OTP sent via SMS on</p>
    <div class="phone-number-container">
        <span class="phone-number-text">{{ phoneNumber }}</span>
        <ng-container *ngIf="!isEditFlow">
            <span class="change-phone-number-text" (click)="goBack()">Change</span>
        </ng-container>
    </div>

    <div class="form-field otp-input-field">
      <input
        type="tel"
        id="otpCode"
        [(ngModel)]="otpCode"
        (input)="onOtpInput()"
        name="otpCode"
        placeholder="Enter 6 Digit OTP"
        maxlength="6"
        pattern="[0-9]{6}"
        required
      />
    </div>

    <div class="resend-otp">
      <button mat-button class="resend-button" [disabled]="resendTimer > 0" (click)="resendOtp()">Resend OTP
        <span *ngIf="resendTimer > 0" class="timer-text">in {{ resendTimer }} seconds</span>
      </button>
    </div>
    <span class="network-info-text">Didn't receive the OTP? Please check your network or check the number you have added</span>
  </div>

  <div class="button-wrapper">
    <button
      mat-raised-button
      color="primary"
      class="submit-otp-button"
      [disabled]="!isOtpValid"
      (click)="onSubmitOtp()"
    >
      <span>Proceed</span>
    </button>
  </div>
</div>